import ParametrageGeneralController from './parametrage.general.controller';

export default {
    template: require('./parametrage.general.html'),
    controller: ParametrageGeneralController
};
